import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';
import {
  useLazyGetNotificationsQuery,
  useMarkAllNotificationsAsReadMutation,
  useResetNotificationCounterMutation,
} from 'app/services/notifications';
import { INotification } from 'app/services/notifications/types';
import PaginatedList from 'Components/Pagination/PaginatedList';
import { useCursorPagination } from 'Components/Pagination/useCursorPagination';
import LoadingSpinner from 'Components/Spinner/LoadingSpinner';

import { useCallback, useEffect, useMemo } from 'react';
import NotifcationCard from './NotificationCard';
import useNewNotificationCounterStateN from './useNewNotificationCounterState';

export default function NotificationsList() {
  const {
    patchAllItems,
    init,
    isLoading,
    list,
    loadPrevious,
    hasNext,
    loadNext,
  } = useCursorPagination(useLazyGetNotificationsQuery, {
    start_from: undefined,
    direction: undefined,
    limit: 12,
    filters: {},
  });

  const counter = useNewNotificationCounterStateN();
  useEffect(() => {
    if (counter === undefined) return;
    counter > 10 ? init() : loadPrevious();
  }, [counter]);

  const hasUnread = useMemo(
    () => (list ? list.some((_) => !_.read) : false),
    [list],
  );

  const [MarkAllAsReadTrigger] = useMarkAllNotificationsAsReadMutation();
  const [ResetCounterTrigger] = useResetNotificationCounterMutation();

  useEffect(() => {
    ResetCounterTrigger();
  }, []);
  const markAllAsReadHandle = useCallback(() => {
    MarkAllAsReadTrigger()
      .unwrap()
      .then(() =>
        patchAllItems((notification) => ({ ...notification, read: true })),
      );
  }, []);

  const onNotificationChange = (updated: INotification) => {
    patchAllItems((n) => (n.id === updated.id ? updated : n));
  };

  return (
    <ScrollContainer>
      <DashboardContainerHeader title="Notifications">
        {hasUnread && (
          <button
            className="text-sm text-green underline"
            onClick={markAllAsReadHandle}
          >
            Mark all as read
          </button>
        )}
      </DashboardContainerHeader>

      <ScrollContainer>
        {/* intentionally wraped the list in a an empty <div> 
          to let the content scroll while mantaining a fixed 
          header while keeping the loader out of view */}
        <div className="">
          <PaginatedList
            gapItems={false}
            notFoundTitle=""
            notFoundSubTitle="No notifications found"
            className={'my-3'}
            isLoading={isLoading}
            data={list}
            renderItem={(n) => (
              <NotifcationCard value={n} onChange={onNotificationChange} />
            )}
          />
        </div>

        <LoadingSpinner active={hasNext} loadMore={loadNext} />
      </ScrollContainer>
    </ScrollContainer>
  );
}
